import { render, staticRenderFns } from "./uppy_docx.vue?vue&type=template&id=17690ca7&scoped=true"
import script from "./uppy_docx.vue?vue&type=script&lang=js"
export * from "./uppy_docx.vue?vue&type=script&lang=js"
import style0 from "./uppy_docx.vue?vue&type=style&index=0&id=17690ca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17690ca7",
  null
  
)

export default component.exports